import { render, staticRenderFns } from "./domains.vue?vue&type=template&id=0b1b5c5c&scoped=true"
import script from "./domains.vue?vue&type=script&lang=js"
export * from "./domains.vue?vue&type=script&lang=js"
import style0 from "./domains.vue?vue&type=style&index=0&id=0b1b5c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1b5c5c",
  null
  
)

export default component.exports